import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface LineChartData {
  name: string;
  [key: string]: string | number;
}

interface LineChartComponentProps {
  data: LineChartData[];
  dataKeys: { key: string; name: string; color: string }[];
  height?: number;
  title?: string;
  /** Fixed width for printable reports; otherwise responsive. */
  width?: number;
}

const LineChartComponent: React.FC<LineChartComponentProps> = ({
  data,
  dataKeys,
  height = 400,
  title,
  width,
}) => {
  const chart = (
    <LineChart
      data={data}
      width={width}
      height={height}
      margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
    >
      <CartesianGrid
        strokeDasharray="3 3"
        className="stroke-gray-200 dark:stroke-gray-700"
      />
      <XAxis
        dataKey="name"
        className="text-gray-600 dark:text-gray-400"
        tick={{ fill: 'currentColor' }}
      />
      <YAxis
        className="text-gray-600 dark:text-gray-400"
        tick={{ fill: 'currentColor' }}
      />
      <Tooltip
        contentStyle={{
          backgroundColor: 'rgb(31 41 55)',
          border: 'none',
          borderRadius: '0.5rem',
          color: 'white',
        }}
      />
      <Legend />
      {dataKeys.map((item) => (
        <Line
          key={item.key}
          isAnimationActive={!width}
          type="monotone"
          dataKey={item.key}
          name={item.name}
          stroke={item.color}
          strokeWidth={2}
          dot={{ fill: item.color, r: 4 }}
          activeDot={{ r: 6 }}
        />
      ))}
    </LineChart>
  );
  return (
    <div className="bg-panel rounded-lg shadow p-6">
      {title && <h3 className="text-lg font-semibold text-heading mb-4">{title}</h3>}
      {width ? chart : <ResponsiveContainer width="100%" height={height}>{chart}</ResponsiveContainer>}
    </div>
  );
};

export default LineChartComponent;
